module.exports = __webpack_public_path__ + "static/media/logo.45e68538.svg";